import { axiosInstance } from '@src/services/common';

type SavedDashboardResponseData = Omit<SavedDashboard, 'analysis' | 'config'> & {
  config: SavedDashboard['config'] & {
    critical_events_detail: Array<Pick<CriticalEvent, 'name' | 'status' | 'source' | 'rules'>>;
  };
};

type AssociatedFunnelAnalysesResponseData = {
  id: string;
  name: string;
};

export async function getFunnelAnalyses() {
  const response = await axiosInstance.get<{ funnel_analyses: SavedDashboardResponseData[] }>(
    '/gm/v1/funnel_analyses',
  );

  return response.data.funnel_analyses.map((item) => ({
    ...item,
    type: 'saved' as const,
    analysis: 'funnel' as const,
  }));
}

export async function getFunnelAnalysis(id: string) {
  const response = await axiosInstance.get<SavedDashboardResponseData>(
    `/gm/v1/funnel_analyses/${id}`,
  );

  return {
    ...response.data,
    type: 'saved' as const,
    analysis: 'funnel' as const,
  };
}

export async function postFunnelAnalysis(data: SavedDashboard['config']) {
  const response = await axiosInstance.post<{ fa_id: string }>('/gm/v1/funnel_analyses', data);

  return response.data.fa_id;
}

export async function putFunnelAnalysis(value: { id: string; data: SavedDashboard['config'] }) {
  await axiosInstance.put(`/gm/v1/funnel_analyses/${value.id}`, value.data);
}

export async function deleteFunnelAnalysis(id: string) {
  await axiosInstance.delete(`/gm/v1/funnel_analyses/${id}`);
}

export async function getDimensionAssociatedFunnelAnalyses(id: string) {
  const response = await axiosInstance.get<{
    funnel_analyses: AssociatedFunnelAnalysesResponseData[];
  }>(`/gm/v1/dimensions/${id}/funnel_analyses`);

  return response.data.funnel_analyses;
}

export async function getCriticalEventAssociatedFunnelAnalyses(id: string) {
  const response = await axiosInstance.get<{
    funnel_analyses: AssociatedFunnelAnalysesResponseData[];
  }>(`/gm/v1/critical_events/${id}/funnel_analyses`);

  return response.data.funnel_analyses;
}
